






import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AuditForm from './auditInfoForm.vue'

@Component({
	name: 'partnerAddAuditInfo',
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		PageLayout,
		AuditForm,
	},
})
export default class partnerAddAuditInfo extends Vue {}
